/**
 * Created by kb on 2017/11/20.
 */
import { http_Req,url,METHODS } from '@/api/httpService'
import { asyncRouterMap, constantRouterMap,getDeskRoute } from '../../router'
import {util} from '@/commonJs/util'
import {reqUrlConf}  from  '@/commonJs/reqconf'
import  {menuPage} from  '@/commonJs/commonconf'

{
  /**
   * 递归过滤异步路由表，返回符合用户角色权限的路由表
   * @param asyncRouterMap
   * @param roles
   */
  let filterAsyncRouter= function (asyncRouterMap, roles,pPath) {
    let accessedRouters = asyncRouterMap.filter(route => {
      if (hasPermission(roles, route, pPath)) {
        if (route.children && route.children.length) {
          route.children = filterAsyncRouter(route.children, roles, route.path)
        }
        return true
      }
      return false
    })
    return accessedRouters
  }

  /**
   * 通过meta.role判断是否与当前用户权限匹配
   * @param roles 权限列表
   * @param route  当前路由
   * @param pPath   父路由路径
   */
  let hasPermission  =  function (roles, route,pPath) {
    if (!route.meta || route.meta.permission) {
      let fullPath = pPath.notBlank() ? pPath + "/" + route.path : route.path;
      return roles.some(role => {
        return new RegExp("^" + role + "{1}([\/\?]{1}[^]*)?$", "i").test(fullPath)
      })
    } else {
      return true
    }
  }


 let filterMenuPath  =  function (menus,accsseRoutes) {
    menus.forEach((item, index) => {
      if (item.menuUrl && item.menuUrl.notBlank()) {
        accsseRoutes.indexOf($.trim(item.menuUrl)) === -1 && accsseRoutes.push($.trim(item.menuUrl))
      }
      if (item.children && item.children.length > 0) {
        filterMenuPath(item.children, accsseRoutes)
      }
    })
  }

  let getUser =  function () {
    if (sessionStorage.getItem('user')) {
      try {
        return JSON.parse(sessionStorage.getItem('user'))
      } catch (e) {
        return undefined;
      }
    }
    return undefined;
  }

  let  getMenus = function () {
    if (sessionStorage.getItem('leftMenus')) {
      try {
        return JSON.parse(sessionStorage.getItem('leftMenus'))
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  var system = {
    namespaced: true,
    state(){
      return {
        roles: [],//用户权限
        user: getUser(),//用户信息
        token: sessionStorage.getItem('token') || undefined, //请求Token
        routers: [],//静态路由列表
        addRouters: [], //动态路由列表
        menus: getMenus(), //菜单信息
        PagePermissions:[],//界面按钮权限列表
        isLoading: false,//界面是否加载中
      }
    },
    mutations: {
      SET_ROLES: (state, roles) => {
        state.roles = roles;
      },
      SET_USER: (state, user) => {
        state.user = user;
      },
      SET_TOKEN: (state, token) => {
        state.token = token;
      },
      SET_MENUS: (state, menus) => {
        state.menus = menus;
      },
      SET_ROUTERS(state, routes){
        state.routers = state.routers.concat(routes);
        state.addRoutes = routes;
      },
      SET_PagePermissions: (state, PagePermissions) => {
        state.PagePermissions = PagePermissions;
      },
      SET_LODING: (state, isLoading) => {
        state.isLoading = isLoading;
      },
    },
    actions: {
      //登录方法
      LoginByUserName({commit, state}, userInfo){
        return new Promise((resolve, reject) => {
          http_Req(METHODS.POST, "/sys/login", userInfo).then(({reqStatus, record, errMsg}) => {
            if (reqStatus) {
              commit('SET_TOKEN', record.userToken);
              commit('SET_USER', record.user);
              sessionStorage.setItem('token', record.userToken);//缓存Token
              sessionStorage.setItem("user", JSON.stringify(record.user)); //缓存用户信息
              window.sessionStorage.removeItem('leftMenus') //清除缓存的左菜单
              resolve();
            } else {
              reject(new Error(errMsg))
            }
          }).catch((e) => {
            reject(new Error("登录失败，服务器异常"))
          })
        })
      },
      //获取动态路由方法
      GeneraRouter({commit, state}, roles){
        return new Promise((resolve, reject) => {
          try {
            let accessedRouters = []
            if (process.env.IsfilterAsyncRoutes) {
              accessedRouters = filterAsyncRouter(asyncRouterMap, roles, "");

            } else {
              accessedRouters = [...asyncRouterMap]
            }
            let deskRoute = getDeskRoute();
            accessedRouters.push(deskRoute);
            commit('SET_ROUTERS', accessedRouters)
            resolve(accessedRouters)
          } catch (e) {
            location.href = "/login"
          }
        })
      },
      GetLetMenuRoles({commit, state}){
        return new Promise((resolve, reject) => {
          http_Req(METHODS.GET, "/sys/menu/getLeftMenusByUserId", {}).then(({reqStatus, record, errMsg}) => {
            let accsseRoutes = [];
            record = record || [];
            accsseRoutes = process.env.IsfilterAsyncRoutes ? [] : [''];
            filterMenuPath(record, accsseRoutes);
            commit('SET_ROLES', accsseRoutes);
            sessionStorage.removeItem("leftMenus");
            sessionStorage.setItem('leftMenus', JSON.stringify(record)) //缓存菜单信息
            commit('SET_MENUS', record);
            resolve();
          }).catch((e) => {
            reject(e);
          })
        })
      },
      LoginOut({commit, state}){
        return new Promise((resolve, reject) => {
          commit('SET_ROLES', []);
          commit('SET_MENUS', []);
          commit('SET_TOKEN', undefined);
          commit('SET_USER', undefined);
          commit('SET_ROUTERS', [])
          sessionStorage.removeItem("user")
          sessionStorage.removeItem("token")
          sessionStorage.removeItem("leftMenus")
          resolve();
        });
      },
      GetBtnListByPageCode({commit, state},path){
        let isReturn = false;//是否在指定的时间内返回结果
        let filterRoles = state.roles.filter(value => {
          return value.notBlank();
        })
        return new Promise((resolve, reject) => {
          http_Req(METHODS.GET, reqUrlConf.getMenuByCode, {menuCode: menuPage.pageCode}).then(({reqStatus, record, errMsg}) => {
            if (reqStatus && record.constructor === Array) {
              commit('SET_PagePermissions', [...record])
            } else {
              commit('SET_PagePermissions', [])
            }
            isReturn = true;

            if (!filterRoles.some(role => {
                return new RegExp("^" + role + "{1}([\/\?]{1}[^]*)?$", "i").test(path)
              }) && new RegExp("^/desk{1}([\/\?]{1}[^]*)?$", "i").test(path)) {
              reject(new Error(filterRoles[0]));
            } else {
              resolve();
            }
          }).catch((e) => {
            commit('SET_PagePermissions', [])
            if (!filterRoles.some(role => {
                return new RegExp("^" + role + "{1}([\/\?]{1}[^]*)?$", "i").test(path)
              }) && new RegExp("^/desk{1}([\/\?]{1}[^]*)?$", "i").test(path)) {
              reject(new Error(filterRoles[0]));
            } else {
              resolve();
            }
          })
          //如果请求界面权限过长 则返回空的权限
          setTimeout(function () {
            if(!isReturn){
              commit('SET_PagePermissions', []);
              resolve();
            }
          }, 5000);
        });
      },
    }
  }
}
export default system;



// WEBPACK FOOTER //
// ./src/store/modules/system.js